import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuctionLotListPageComponent } from './pages/auction-lot-list-page/auction-lot-list-page.component';
import { AuctionsPageComponent } from './pages/auctions-page/auctions-page.component';
import { VBProductDetailsComponent } from './pages/vb-product-details/vb-product-details.component';
import { uuidParamsMatchGuard } from '../../shared/guards/uuid-params-match.guard';

const routes: Routes = [
    {
        path: '',
        component: AuctionsPageComponent,
        title: 'Viewbid Auctions - Auctions',
    },
    {
        path: ':auctionId',
        component: AuctionLotListPageComponent,
        title: 'Auction Lot List',
        canMatch: [uuidParamsMatchGuard],
    },
    {
        path: ':auctionId/lot/:lotId',
        component: VBProductDetailsComponent,
        title: 'Lot Detail',
        canMatch: [uuidParamsMatchGuard],
    },
    {
        path: ':auctionId/:auctionLotId',
        component: AuctionLotListPageComponent,
        title: 'Auction Lot List',
        canMatch: [uuidParamsMatchGuard],
    },
    // Catch invalid paths under /auctions. The root '**' wildcard can't be
    // reached across the lazy-load boundary, so redirect them to the 404 page.
    { path: '**', redirectTo: '/404' },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AuctionsRoutingModule {}
